import { Model } from '@vuex-orm/core';
import { uuidv4 } from '../../utils/helpers';
import { UnitType } from './unit-type';
import { Invoice, Product } from './models';

export class InvoiceLine extends Model {
  static entity = 'invoice_lines';

  static fields() {
    return {
      id: this.attr(() => uuidv4()),
      invoice_id: this.attr(null),
      invoice: this.belongsTo(Invoice, 'invoice_id'),
      description: this.attr(null),
      quantity: this.attr(null),
      unit_type_code: this.attr(null),
      unit_type: this.belongsTo(UnitType, 'unit_type_code'),
      price: this.attr(null),
      product_id: this.attr(null),
      product: this.belongsTo(Product, 'product_id'),
      updated_at: this.attr(null),
      created_at: this.attr(null),
    };
  }
}

export default InvoiceLine;
